import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const LoggerBtn = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = computed(() => mainStore.getMainStore("modal")).get();

        const handleClick = () => {
            if (modal?.type === "logger") {
                mainStore.setMainStore("modal", false);
            } else {
                mainStore.setMainStore("modal", { type: "logger" });
            }
        };

        return (
            <ButtonUI className="logger-btn" onClick={handleClick}>
                <i className="pi pi-clock"></i>
                <i className={`pi pi-chevron-${modal?.type === "logger" ? "up" : "down"}`} />
            </ButtonUI>
        );
    }),
);

export default LoggerBtn;
